<div class="container">
  <ng-container *ngFor="let viewItem of extraViewItems">
    <ng-container [ngSwitch]="viewItem.elementType">

      <p *ngSwitchCase="'text'">{{ viewItem.label }}</p>

      <a *ngSwitchCase="'link'" [href]="viewItem.href" target="_blank">
        {{ viewItem.label }}
      </a>

      <input *ngSwitchCase="'input'" [placeholder]="viewItem.placeholder" />

      <img *ngSwitchCase="'image'" [src]="viewItem.src"  />

      <button *ngSwitchCase="'button'">{{ viewItem.label }}</button>

    </ng-container>
  </ng-container>
</div>
